export function canSubmitCheckoutPayment({
  submitting = false,
  totalDueCents = 0,
  tenderedCents = 0,
  hasPlanBucket = false,
  referenceOk = true,
  seniorPwdRemovalApproved = true,
}) {
  const totalDue = Number(totalDueCents ?? 0);
  const tendered = Number(tenderedCents ?? 0);

  if (submitting) return false;
  if (!Number.isFinite(totalDue) || totalDue < 0) return false;
  if (!Number.isFinite(tendered) || tendered < 0) return false;
  if (!referenceOk || !seniorPwdRemovalApproved) return false;

  if (hasPlanBucket) return true;
  if (totalDue === 0) return true;

  // A visit can close with nothing collected today. The database-owned
  // checkout transaction posts the completed charge first, then creates a
  // standalone_underpayment AR row for the full unpaid balance. Blocking
  // zero here would contradict that contract and strand completed care in
  // the Payment step.
  return tendered >= 0;
}

export function calculateCurrentVisitAllocationCreditCentavos({
  tenderedCents = 0,
  priorArSelectedCents = 0,
  allocationTotalCents = 0,
} = {}) {
  const tendered = Number(tenderedCents ?? 0);
  const priorAr = Number(priorArSelectedCents ?? 0);
  const allocated = Number(allocationTotalCents ?? 0);

  if (!Number.isFinite(tendered) || !Number.isFinite(priorAr) || !Number.isFinite(allocated)) {
    return 0;
  }

  const currentVisitTendered = Math.max(0, tendered - Math.max(0, priorAr));
  return Math.max(0, currentVisitTendered - Math.max(0, allocated));
}
